import { render } from "./AppMain.vue?vue&type=template&id=5ec1cfad&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=5ec1cfad&lang=scss&scoped=true"
import "./AppMain.vue?vue&type=style&index=1&id=5ec1cfad&lang=scss"

import exportComponent from "/var/publish/zonghe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec1cfad"]])

export default __exports__